const html = require('choo/html');
const raw = require('choo/html/raw');
const { create } = require('qrcode/lib/core/qrcode');

const MARGIN = 2; // quiet zone, in modules

// Renders the QR code as inline SVG paths (no data: URL or inline style,
// so it works with the production CSP)
function toSvg(text) {
  const { modules } = create(text, { errorCorrectionLevel: 'M' });
  const size = modules.size;
  const total = size + MARGIN * 2;
  let path = '';
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      if (modules.get(y, x)) {
        path += `M${x + MARGIN} ${y + MARGIN}h1v1h-1z`;
      }
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${total} ${total}" shape-rendering="crispEdges" class="w-full h-full"><rect width="${total}" height="${total}" fill="#ffffff"/><path d="${path}" fill="#000000"/></svg>`;
}

module.exports = function qrcode(state, url) {
  const label = state.translate('qrCodeDescription');
  return html`
    <send-qrcode
      class="block w-48 h-48 my-2 p-1 bg-white rounded-lg border border-grey-30 dark:border-grey-70"
      role="img"
      aria-label="${label}"
    >
      ${raw(toSvg(url))}
    </send-qrcode>
  `;
};
